import { Link } from 'react-router-dom';
import { useUser } from '../../apiClient/ApiContext';
import { RoleDisplay } from '../../utils/enums';

export default function UserPanel() {
  const user = useUser();

  return (
    <Link to="/account" style={{ textDecoration: 'none' }}>
      <div className="flex items-center gap-4 @[100px]:pl-10 pl-4 pb-8 pt-4">
        <div className="rounded-full size-10 text-center content-center uppercase bg-white">
          {user?.person?.first_name[0]}
          {user?.person?.last_name[0]}
        </div>
        <div className="flex-col hidden @[100px]:flex flex-nowrap">
          <div className="text-body-2-xl text-secondary-500 font-semibold">
            {user?.person?.first_name} {user?.person?.last_name}
          </div>
          <div className="text-caption-xl text-secondary-400">
            {user?.role?.map((r) => r.slug && RoleDisplay[r.slug]).join(', ')}
          </div>
        </div>
      </div>
    </Link>
  );
}
